import { createFileRoute, redirect } from "@tanstack/react-router";
import { CurlyBracesIcon, GlobeIcon } from "lucide-react";
import { GoogleAdsIcon } from "~/components/icons/google-ads-icon";
import { EmptyState } from "~/components/ui/empty-state";
import { useImperativeDialogRef } from "~/hooks/use-imperative-dialog";
import { queryClient, trpc } from "~/lib/trpc";
import { AddPageDialog } from "~/routes/(app)/pages/$pageId/-components/add-page-dialog";

export const Route = createFileRoute("/(app)/pages/")({
  component: PagesComponent,
  beforeLoad: async () => {
    const pageOptions = await queryClient.ensureQueryData(
      trpc.pages.getPageCrumbOptions.queryOptions(),
    );

    if (pageOptions && pageOptions.length > 0) {
      const lastViewedPageId = localStorage.getItem("lastViewedPageId");

      const redirectPage =
        pageOptions.find((p: any) => p.id === lastViewedPageId) ??
        pageOptions[0];

      throw redirect({
        to: "/pages/$pageId/variants",
        params: { pageId: redirectPage.id },
      });
    }
  },
  loader: async () => {
    return {
      showEmptyState: true,
      crumb: {
        label: "Page Variants",
        options: [],
        id: "pages",
      },
    };
  },
});

function PagesComponent() {
  const addPageDialogRef = useImperativeDialogRef();

  return (
    <div className="flex items-center justify-center h-full px-4 py-12 sm:px-6 md:px-8 lg:px-12 xl:px-16 -mt-16">
      <EmptyState
        title="Let's personalize your page!"
        description="Start by adding your first page to create personalized variants for specific audiences."
        icons={[
          () => <GlobeIcon className="text-green-600" />,
          GoogleAdsIcon,
          () => <CurlyBracesIcon className="text-yellow-500" />,
        ]}
        action={{
          label: "Add your first page",
          onClick: () => {
            addPageDialogRef.current?.open();
          },
        }}
      />
      <AddPageDialog ref={addPageDialogRef} />
    </div>
  );
}
